import { takeLatest, all, select } from 'redux-saga/effects';
import { getReviewsCount } from 'src/store/reviews/selectors';
import { takeOnce } from '../../../../helpers/effects';
import { dataLayerPush } from '../../../../helpers/gtm';

import { INIT_APP } from '../../../../store/view/constants';
import { SHOW_PAGE } from '../constants/view';
import {
  getHotelId,
  getHotelStars,
  getHotelCoordinates,
  getHotelName,
} from '../selectors/hotel';

const CATEGORY = 'hotel_reviews_page';

/**
 * Собирает данные для события ccx-pageview
 */
function* collectCcxPageviewData() {
  const hotelId = yield select(getHotelId);
  const stars = yield select(getHotelStars);
  const coordinates = yield select(getHotelCoordinates);
  const { lat, long } = coordinates || {};
  const hotelName = yield select(getHotelName);
  const reviewsCount = yield select(getReviewsCount);

  return {
    id: hotelId,
    latitude: Number(lat),
    longitude: Number(long),
    name: hotelName,
    rating: null, // TODO: какой рейтинг передавать?
    reviews_count: reviewsCount,
    stars,
  };
}

function pushInitialized() {
  dataLayerPush({
    event: 'initizialized',
    eventCategory: CATEGORY,
    eventLabel: 'Hotel Reviews page inited',
  });
}

/**
 * Отправляет событие ccx-pageview
 */
function* pushCcxPageview() {
  try {
    const data = yield collectCcxPageviewData();
    dataLayerPush({
      event: 'ccx-pageview',
      eventCategory: CATEGORY,
      hotel_params: data,
    });
  } catch (error) {
    console.log('Can not push ccx-pageview', error);
  }
}

/**
 * Старт приложения
 */
function* onInitApp() {
  pushInitialized();
  yield pushCcxPageview();
}

/**
 * Отправляет события при переходе по страницам
 */
function onChangePage({ payload }) {
  const eventNames = {
    reviews: 'reviews',
    map: 'map',
  };
  const event = payload ? eventNames[payload] : 'back_to_hotel_reviews_page';
  dataLayerPush({
    event,
    eventCategory: CATEGORY,
  });
}

export default function* () {
  yield all([
    takeOnce(INIT_APP, onInitApp),
    takeLatest(SHOW_PAGE, onChangePage),
  ]);
}
